import { Injectable, inject } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';

@Injectable()
export class SchedulesService {
  private readonly http = inject(NgrxHttpClient);

  private formatParams(params) {
    const { type, ...rest } = params;
    const payload = {
      ...rest,
      ...(type && { schedule_type: type })
    };
    return payload;
  }

  createNewSchedule(params) {
    const payload = this.formatParams(params);
    return this.http.post('createnewhomeschedule', payload);
  }

  modifySchedule(params) {
    const payload = this.formatParams(params);
    return this.http.post('synchomeschedule', payload);
  }

  switchHomeSchedule(params) {
    return this.http.get('switchhomeschedule', params);
  }

  deleteschedule(params) {
    return this.http.get('deleteschedule', params);
  }
}
